<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#">IPTv Admin</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Channel
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Category
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Tags
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Subscriber
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Admin
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Statistics
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">STB</a>
              <a class="dropdown-item" href="#">Subscriber</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Settings
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">Global</a>
              <a class="dropdown-item" href="#">OSD</a>
              <a class="dropdown-item" href="#">Fingerprint</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Mail
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              EPG
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              STB
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">List</a>
              <a class="dropdown-item" href="#">Create</a>
            </div>
          </li>
      </ul>
      <form class="form-inline my-2 my-lg-0">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
      </form>
    </div>
  </nav> -->
<app-top-nav></app-top-nav>
<!-- <div class="navbar__side opened__nav">
  <ul class="side__menu">
    <a [routerLink]="['dashboard']">
      <li [routerLinkActive]="['active']">Dashboard</li>
    </a>
    <a [routerLink]="['admin']">
      <li [routerLinkActive]="['active']">Admin</li>
    </a>
    <a [routerLink]="['lco']">
      <li [routerLinkActive]="['active']">LCO</li>
    </a>
    <a [routerLink]="['subscriber']">
      <li [routerLinkActive]="['active']">Subscriber</li>
    </a>
    <a [routerLink]="['stb']">
      <li [routerLinkActive]="['active']">STB</li>
    </a>
    <a [routerLink]="['channel']">
      <li [routerLinkActive]="['active']">Channel</li>
    </a>
    <a [routerLink]="['category']">
      <li [routerLinkActive]="['active']">Category</li>
    </a>
    <a [routerLink]="['broadcaster']">
      <li [routerLinkActive]="['active']">Broadcaster</li>
    </a>
    <a [routerLink]="['packages']">
      <li [routerLinkActive]="['active']">Packages</li>
    </a>
    <a [routerLink]="['location']">
      <li [routerLinkActive]="['active']">Location</li>
    </a>
    <a [routerLink]="['transcoder']">
      <li [routerLinkActive]="['active']">Transcoder</li>
    </a>
    <a [routerLink]="['epg']">
      <li [routerLinkActive]="['active']">EPG</li>
    </a>
    <a [routerLink]="['mail']">
      <li [routerLinkActive]="['active']">Mail</li>
    </a>
    <a [routerLink]="['osd']">
      <li [routerLinkActive]="['active']">OSD</li>
    </a>
    <div [routerLinkActive]="['active']">
      <a [routerLink]="['reports']">
        <li>Reports</li>
      </a>
      <a [routerLink]="['trai-reports']" class="hidden-link"></a>
      <a [routerLink]="['broadcaster-reports']" class="hidden-link"></a>
    </div>
    <a [routerLink]="['fingerprint']">
      <li [routerLinkActive]="['active']">Fingerprint</li>
    </a>
    <a [routerLink]="['settings']">
      <li [routerLinkActive]="['active']">Settings</li>
    </a>
  </ul>
  <span>Onnet Systems 2021 | All Rights Reserved</span>
</div> -->